export const ROLES = Object.freeze({
  ADMIN: "admin",
  PROJECT_MANAGER: "pm",
  ADMINISTRATIVE_EMPLOYEE: "administrative-employee",
  HEAD: "head",
  TEAMLEAD: "teamlead",
  employee: "employee",
  GPM: "gpm",
  WALLET: "wallet",
});
